<app-role-access [action]="'disable'" [permission]="'brigade.edit'" [placement]="'bottom-left'">
  <button
    data-role-element
    [ngbPopover]="userActionsPopContent"
    placement="{{ placement }}"
    triggers="manual"
    #p2="ngbPopover"
    (click)="toggleWithUserActionsContext(p2)"
    class="cur-pointer"
    id="{{ 'appOpenUserActionsPopover' + user.u_id }}"
  >
    <app-icon [color]="'red-gray-dark'" [size]="'14'" [glyph]="'dots'"></app-icon>
  </button>
</app-role-access>

<ng-template #userActionsPopContent>
  <div *ngIf="user && !brigade">
    <div
      class="grid grid--gap-8 mb-8 cur-pointer"
      *ngIf="user && user.employer && user.employer.employee_type && user.employer.employee_type.et_id === 2"
      (click)="onOpenCreateBrigadeDialog()"
      id="{{ 'appOpenCreateBrigadeUnassignedUserDialog' + user.u_id }}"
    >
      <div class="grid__box grid__box--size-min pt-2">
        <app-icon [color]="'gray-dark'" [size]="'16'" [glyph]="'create'"></app-icon>
      </div>
      <div class="grid__box grid__box--size-min">
        <span class="link link--dotted-blue-dark">Сформировать бригаду</span>
      </div>
    </div>
    <div class="grid grid--gap-8 cur-pointer" (click)="onMoveUserNewBrigadeDialog()" id="{{ 'appOpenMoveBrigadeUnassignedUserDialog' + user.u_id }}">
      <div class="grid__box grid__box--size-min pt-2">
        <app-icon [color]="'gray-dark'" [size]="'16'" [glyph]="'move'"></app-icon>
      </div>
      <div class="grid__box grid__box--size-min">
        <span class="link link--dotted-blue-dark">Перенести в бригаду</span>
      </div>
    </div>
  </div>
  <div *ngIf="user && brigade">
    <div
      class="grid grid--gap-8 mb-8 cur-pointer"
      *ngIf="user && user.employer && user.employer.employee_type && user.employer.employee_type.et_id === 2 && brigade.brigade_workers && brigade.brigade_workers.length"
      (click)="onOpenCreateBrigadeDialog()"
      id="{{ 'appOpenCreateBrigadeUserDialog' + user.u_id }}"
    >
      <div class="grid__box grid__box--size-min pt-2">
        <app-icon [color]="'gray-dark'" [size]="'16'" [glyph]="'create'"></app-icon>
      </div>
      <div class="grid__box grid__box--size-min">
        <span class="link link--dotted-blue-dark">Сформировать бригаду</span>
      </div>
    </div>
    <div class="grid grid--gap-8 mb-8 cur-pointer" (click)="onMoveUserNewBrigadeDialog()" id="{{ 'appOpenMoveBrigadeUserDialog' + user.u_id }}">
      <div class="grid__box grid__box--size-min pt-2">
        <app-icon [color]="'gray-dark'" [size]="'16'" [glyph]="'move'"></app-icon>
      </div>
      <div class="grid__box grid__box--size-min">
        <span class="link link--dotted-blue-dark">Перенести в бригаду</span>
      </div>
    </div>
    <div class="grid grid--gap-8 cur-pointer" (click)="onRemoveUserFromBrigade()" id="{{ 'appOpenRemoveBrigadeUserDialog' + user.u_id }}">
      <div class="grid__box grid__box--size-min pt-2">
        <app-icon [color]="'gray-dark'" [size]="'16'" [glyph]="'hd-close-small'"></app-icon>
      </div>
      <div class="grid__box grid__box--size-min">
        <span class="link link--dotted-blue-dark">Удалить из бригады</span>
      </div>
    </div>

    <div
      class="grid grid--gap-8 mt-8 cur-pointer"
      *ngIf="user && user.employer && user.employer.employee_type && user.employer.employee_type.et_id === 2 && user.u_id !== brigade.brigade_head.u_id"
      (click)="makeMainHeadInCurrentBrigade()"
      id="{{ 'appOpenChangeBrigadeHeadDialog' + user.u_id }}"
    >
      <div class="grid__box grid__box--size-min pt-2">
        <app-icon [color]="'gray-dark'" [size]="'16'" [glyph]="'admin'"></app-icon>
      </div>
      <div class="grid__box grid__box--size-min">
        <span class="link link--dotted-blue-dark">Назначить бригадиром</span>
      </div>
    </div>
  </div>
</ng-template>
